import { get, minBy } from 'lodash'
import moment from 'moment'

export const headers = (intl = {}) => [
  intl.formatMessage({
    id: 'table.id'
  }),
  intl.formatMessage({
    id: 'table.name'
  }),
  intl.formatMessage({
    id: 'table.coordinator'
  }),
  intl.formatMessage({
    id: 'table.type'
  }),
  intl.formatMessage({
    id: 'table.nao'
  }),
  intl.formatMessage({
    id: 'table.state'
  })
]

export const line = (data = []) =>
  data.map(item => {
    let activeCoordinator = item.coordinators[0]

    if (item.coordinators.length > 1) {
      activeCoordinator = minBy(item.coordinators, coord =>
        moment(get(coord, 'person.createdAt'))
      )
    }
    return {
      line: [
        item.globalId || item.id,
        item.name,
        `${get(activeCoordinator, 'firstName') ||
          get(activeCoordinator, 'person.firstName') ||
          ''} ${get(activeCoordinator, 'lastName') ||
          get(activeCoordinator, 'person.lastName') ||
          ''}`,
        get(item, 'organizationType.translationText'),
        get(item, 'parentNAO.name'),
        get(item, 'approvementState.translationText')
      ]
    }
  })
